import type { FC, ReactNode } from 'react';

interface ModalProps {
  title: string;
  onClose: () => void;
  size?: 'sm' | 'md' | 'lg';
  closeDisabled?: boolean;
  children: ReactNode;
}

const Modal: FC<ModalProps> = ({ title, onClose, size = 'md', closeDisabled, children }) => {
  const dialogClass = size === 'lg' ? 'modal-lg' : size === 'sm' ? 'modal-sm' : '';
  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className={`modal-dialog modal-dialog-centered ${dialogClass}`}>
        <div className="modal-content">
          <div className="modal-header py-2">
            <h6 className="modal-title">{title}</h6>
            <button type="button" className="btn-close btn-close-sm" onClick={onClose} disabled={closeDisabled} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
